<template>
  <cube-button active>激活态</cube-button>
</template>

<script>
import { createComponent } from '@mpxjs/core'

createComponent({})
</script>

<script type="application/json">
  {
    "usingComponents": {
      "cube-button": "@mpxjs/mpx-cube-ui/src/components/button/index"
    }
  }
</script>
